export default "__VITE_PUBLIC_ASSET__6bcbfa7b__"